import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDialog, MatDialogRef, MatSelect, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { DialogService, FormulaireService, SuiviService, TiersService } from '../../../../../services'
const KEY = 'suivi-actions-dialog'

@Component({
	selector: 'atyl-suivi-actions-dialog',
	templateUrl: './suivi-actions-dialog.component.html',
	styleUrls: ['./suivi-actions-dialog.component.scss']
})
@Stringable({
	path: 'views/partials/content/actions/suivi-actions-dialog',
	key: KEY
})
export class SuiviActionsDialog extends BaseDialogComponent implements OnInit {

	selectable: boolean = true;
	removable: boolean = true;
	separatorKeysCodes: number[] = [ENTER, COMMA];
	tiersCtrl = new FormControl();

	currentAction: string
	currentDataType: string
	dossier: any
	suivi: any
	suiviTypeList: any[] = [];
	listSubscription: any[] = [];
	suiviLibelle: string = '';
	suiviType: any
	suiviDateDebut: any
	suiviDateFin: any
	suiviDescription: string = '';
	suiviCurrentEtat: number = 1;
	suiviSearchTerm: string
	updateSuiviSearchTerm = new Subject<string>();
	loading: boolean = false;
	searchDisabeld: boolean = true;
	tiersSearchList: any[] = [];
	selectedTiers: any[] = [];
	suiviTypeError: string = '';
	selectedSuiviType: any
	suiviOrigines = [];
	@ViewChild('tiersInput', { read: undefined, static: undefined }) tiersInput: ElementRef<HTMLInputElement>
	@ViewChild('suivitypeinput', { read: undefined, static: undefined }) suivitypeinput: ElementRef<MatSelect>
	@StringableValues(KEY) strings: any
	constructor(
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<SuiviActionsDialog>,
		private suiviService: SuiviService,
		private tiersServices: TiersService,
		private _snackBar: MatSnackBar,
		private formulaireService: FormulaireService,
		public dialog: MatDialog,
		dialogService: DialogService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {

		this.loading = true
		if (this.data) {
			this.currentAction = this.data.action
			this.currentDataType = this.data.dataType
			this.dossier = this.data.dossier
		}
		if (this.data.suivi) {
			this.suivi = this.data.suivi
			this.prefillForm(this.suivi)
			this.getOrigineData()
		}

		this.tiersCtrl.valueChanges.pipe(
			debounceTime(400),
			distinctUntilChanged()
		).subscribe(term => {
			this.tiersServices.searchTiersForSuivi(term, { suiviType: this.suiviType }).subscribe((res: JSONRpcResponse) => {
				this.tiersSearchList = res.result
				this.changeDetectorRef.detectChanges()
			})
		})



		this.listSubscription.push(
			this.suiviService.getSuiviTypeList().subscribe((res: JSONRpcResponse) => {
				this.suiviTypeList = res.result
				this.loading = false
				this.changeDetectorRef.detectChanges()
			})
		)

	}
	updateDate(event: any) {
	}
	suiviTypeChanged(event: any) {

		if (event.value !== undefined) {
			this.selectedSuiviType = event.value
			this.searchDisabeld = false
			this.suiviTypeError = ''
			this.changeDetectorRef.detectChanges()
		} else {
			this.searchDisabeld = true
			this.changeDetectorRef.detectChanges()
		}

	}

	selectTiers(tiers: any) {
		if (this.selectedTiers.indexOf(tiers) === -1) {
			this.selectedTiers.push(tiers)
		}
		this.suiviSearchTerm = ''
		this.tiersSearchList = []
		this.changeDetectorRef.detectChanges()
	}

	supprimer(tiers: any) {
		const index = this.selectedTiers.indexOf(tiers)
		if (index >= 0) {
			this.selectedTiers.splice(index, 1)
		}
		this.changeDetectorRef.detectChanges()
	}
	ajouter(event: any) {
		const value = (event.value || '').trim()

		if (value) {
			this.selectedTiers.push(value)
		}
		event.chipInput.clear()

		this.tiersCtrl.setValue(null)
	}
	selected(event: any) {
		this.selectedTiers.push(event.option.value)
		this.tiersInput.nativeElement.value = ''
		this.tiersCtrl.setValue(null)
	}
	submitSuiviForm(event: any) {
		if (this.suiviType === undefined) {
			this.suiviTypeError = 'Veuillez selectionner un type de suivi'
			this.changeDetectorRef.detectChanges()
			return
		}
		const newSuivi = {
			id: this.data.suivi ? this.data.suivi.ID : '',
			typeId: this.suiviType,
			dossierId: this.dossier.ID,
		}
		const _options = {
			datedebut: this.suiviDateDebut,
			datefin: this.suiviDateFin,
			description: this.suiviDescription,
			libelle: this.suiviLibelle,
			professionels: this.idFiy(this.selectedTiers)
		}
		this.loading = true
		this.suiviService.set(newSuivi.id, newSuivi.dossierId, newSuivi.typeId, _options).subscribe((res: JSONRpcResponse) => {
			this.loading = false
			this._snackBar.open('Suivi ajouté avec succès', 'Fermer', {
				duration: 6000,
			})
			this.dialogRef.close(res.result)
		})
	}
	closeDialog() {
		this.dialogRef.close()
	}
	idFiy(array: any[]) {
		return array.map(item => item.id)
	}
	prefillForm(suivi: any) {
		this.selectedSuiviType = suivi.type.key
		this.suiviType = suivi.type.key
		this.suiviLibelle = suivi.label
		this.suiviDateDebut = new Date(suivi.datedebut)
		this.suiviDateFin = new Date(suivi.datefin)
		this.suiviDescription = suivi.description
		this.suiviCurrentEtat = suivi.etat

		suivi.professionels.forEach((prof: any) => {
			this.selectedTiers.push(prof.professionel)
		})
		if (this.selectedSuiviType !== undefined) {
			this.searchDisabeld = false
		}
		this.changeDetectorRef.detectChanges()
	}
	getOrigineData() {
		/*this.data.suivi.origines.forEach((item: any) => {
			const result = {
				ID: item.ID,
				datecreate: item.datecreate,
				etat: item.etat,
				demandeFormulaire: null,
			}
			if (item.demandeFormulaire != null) {
				this.formulaireService.get(item.demandeFormulaire).subscribe((res: JSONRpcResponse) => {
					result.demandeFormulaire = res.result
					this.suiviOrigines.push(result)
				})
			} else {
				this.suiviOrigines.push(result)
			}
		})
		*/
		this.changeDetectorRef.detectChanges()
	}
	openOrigine(origine: any) {
		if (origine.demandeFormulaire !== null || origine.demandeFormulaire !== undefined) {

			const afterCloseData = {
				navigate: true,
				demandeFormulaire: origine.demandeFormulaire,
				dossier: this.dossier,
			}
			let datasF = {
				title: afterCloseData.demandeFormulaire.form.libelle,
				id: afterCloseData.demandeFormulaire.ID,
				formType: afterCloseData.demandeFormulaire.key,

				idDemandeForm: afterCloseData.demandeFormulaire.form.ID,

			}
			this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				data: datasF,
				height: '90vh',
				width: "90vw",
				draggable: true,
				resizable: true,
				minimizable: true,
				maximizable: true,
			})
		}
	}
}
